import React from 'react';
import PropTypes from 'prop-types';
import { useRequestData } from 'wsm-common-data';

const DisclaimerText = ({ text, isSuperscript = false }) => {
	const { deviceType } = useRequestData();
	const isMobile = deviceType === 'MOBILE';
	const termFontSize = isMobile ? 'small' : 'xsmall';
	
	const className = `text-muted ddc-font-size-${termFontSize}`;
	const Component = isSuperscript ? 'sup' : 'span';

	return (
		<Component className={className}>
			{text}
		</Component>
	);
};

DisclaimerText.propTypes = {
	text: PropTypes.string.isRequired,
	isSuperscript: PropTypes.bool
};

export default DisclaimerText;